export default __webpack_public_path__ + "static/Montserrat-Bold-dbf9cc3b5d0be686036798f4c2ed9c04.woff2";